import { stringifyGraph } from '@/clients/http'
import { RoleModel } from '@/http/models/Role'

import { useFetchList } from '@/hooks/useFetchList'

import { RoleHttpParams, RoleModel as RoleType } from '@/types'

export interface RoleFilters {
  search?: string
}

interface UseFetchRolesProps {
  sort?: string | null
}

export const useFetchRoles = ({ sort }: UseFetchRolesProps = {}) => {
  return useFetchList<RoleFilters, RoleType.Role, {}, any, typeof RoleModel.getList>({
    pageSize: 10,
    initialFilters: {
      search: '',
    },
    fetchFunction: RoleModel.getList,
    sort,
    buildQueryParams: (filters): Partial<RoleHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      graph_enc: stringifyGraph({
        '*': true,
        _timestamps: true,
      }),
    }),
  })
}
